import { jsx as _jsx } from "react/jsx-runtime";
import { memo } from 'react';
import { Rect } from 'react-konva';
const SelectionRect = ({ selectionRect }) => {
    const x = Math.min(selectionRect.x, selectionRect.x + selectionRect.w);
    const y = Math.min(selectionRect.y, selectionRect.y + selectionRect.h);
    const width = Math.abs(selectionRect.w);
    const height = Math.abs(selectionRect.h);
    return (_jsx(Rect, { x: x, y: y, width: width, height: height, stroke: "#0066ffff", strokeWidth: 0.4, strokeScaleEnabled: false, fill: "rgba(30, 113, 229, 0.1)", opacity: 1 }));
};
export default memo(SelectionRect, (prevProps, nextProps) => {
    // Сравниваем только релевантные свойства
    return (prevProps.selectionRect.x === nextProps.selectionRect.x &&
        prevProps.selectionRect.y === nextProps.selectionRect.y &&
        prevProps.selectionRect.w === nextProps.selectionRect.w &&
        prevProps.selectionRect.h === nextProps.selectionRect.h);
});
